import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { JobDetail } from '../../../models/jobDetail';
import { EnvironmentVariables } from '../../../models/environmentVariables';
import { CachedProjectService } from '../../../shared/services/cached-project.service';

@Component({
    selector: 'app-env-vars',
    templateUrl: './env-vars.component.html',
    styleUrls: ['./env-vars.component.css'],
    standalone: false
})
export class EnvVarsComponent implements OnInit, OnDestroy {
  currentJob: JobDetail | null = null;
  envvars: EnvironmentVariables = {};
  
  // Categorized environment variables
  schedulerEnvVars: { key: string; value: string }[] = [];
  slaveEnvVars: { key: string; value: string }[] = [];
  otherEnvVars: { key: string; value: string }[] = [];
  standardEnvVars: { key: string; value: string }[] = [];

  loading = false;
  error: string | null = null;
  
  private currentJobSubscription: Subscription | null = null;

  constructor(private projectService: CachedProjectService) {}

  ngOnInit() {
    this.currentJobSubscription = this.projectService.currentJob.subscribe(
      (job) => {
        if (job) {
          this.currentJob = job;
          this.loadEnvVariables();
        }
      }
    );
  }

  ngOnDestroy() {
    if (this.currentJobSubscription) {
      this.currentJobSubscription.unsubscribe();
    }
  }

  loadEnvVariables() {
    if (!this.currentJob?.id) return;

    this.loading = true;
    this.error = null;

    this.projectService.getEnvVariables(this.currentJob.id).pipe(take(1)).subscribe({
      next: (result: any) => {
        this.envvars = result.envvars || {};
        this.categorizeEnvVariables();
        this.loading = false;
      },
      error: (error) => {
        console.error('Error loading environment variables:', error);
        this.error = 'Failed to load environment variables';
        this.loading = false;
      }
    });
  }

  refreshEnvVariables() {
    if (!this.currentJob?.id) return;

    this.loading = true;
    this.error = null;

    this.projectService.refreshEnvVariables(this.currentJob.id).pipe(take(1)).subscribe({
      next: () => {
        // After refresh, reload the env variables
        this.loadEnvVariables();
      },
      error: (error) => {
        console.error('Error refreshing environment variables:', error);
        this.error = 'Failed to refresh environment variables';
        this.loading = false;
      }
    });
  }

  private categorizeEnvVariables() {
    this.schedulerEnvVars = [];
    this.slaveEnvVars = [];
    this.otherEnvVars = [];

    Object.keys(this.envvars).forEach(key => {
      const envVar = { key, value: this.envvars[key] };
      
       if (key.startsWith('SCHEDULER_')) {
        this.schedulerEnvVars.push(envVar);
      } else if (key.startsWith('SLAVES_')) {
        this.slaveEnvVars.push(envVar);
      } else {
        this.otherEnvVars.push(envVar);
      }
    });

    // Sort each category alphabetically
    this.schedulerEnvVars.sort((a, b) => a.key.localeCompare(b.key));
    this.slaveEnvVars.sort((a, b) => a.key.localeCompare(b.key));
    this.otherEnvVars.sort((a, b) => a.key.localeCompare(b.key));
  }
} 